import React from "react";

import { BridgeEvent } from "@unu/ui-enums";

import { buildMessage, sendEvent } from "@unu/ui-common";

import { useInsights } from "@unu/ui-hooks";

import { registerEvents } from "@unu/web-native-bridge";

export const NativeBridgeProvider = () => {
  const { traceError, traceWarning } = useInsights();
  const sendMessage = React.useCallback(
    ({ name, data }: { name?: string; data?: any } = {}) => {
      if (!name) {
        traceWarning(
          "Attempted to send invalid bridge message - no name provided."
        );
        return;
      }

      if (
        !name ||
        typeof window?.ReactNativeWebView?.postMessage !== "function"
      ) {
        traceError(
          new Error(
            "Unable to send message over native bridge - bridge is not available."
          )
        );
        return;
      }

      try {
        window.ReactNativeWebView.postMessage(
          buildMessage({
            name,
            data,
          })
        );
      } catch (error) {
        traceError("Error sending message over native bridge", error);
      }
    },
    [traceError, traceWarning]
  );

  React.useEffect(() => {
    const events = {
      [BridgeEvent.SendData]: sendMessage,
      [BridgeEvent.ReceiveData]: (data: any) => {
        sendEvent(data);
      },
    };

    return registerEvents(events);
  }, [sendMessage]);

  return <React.Fragment />;
};
